import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { palette } from '@livable/saas-react-components';
import { makeStyles } from '@mui/styles';
import helpers from 'src/styles/helpers';
const useStyles = makeStyles(_objectSpread(_objectSpread({}, helpers), {}, {
  verifiedMobile: {
    padding: '18px 24px',
    backgroundColor: palette.success.light,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    '& .MuiSvgIcon-root': {
      marginRight: '10px',
      '& path': {
        fill: palette.success.main
      }
    }
  },
  authFieldWrapper: {
    alignItems: 'center',
    backgroundColor: palette.shades[200],
    marginTop: props => props.insideModal ? '0px' : '32px',
    display: 'flex',
    padding: '18px 24px',
    '& + &': {
      marginTop: '10px'
    }
  },
  methodBlock: {
    borderTop: "1px solid ".concat(palette.shades[200]),
    marginTop: '24px',
    paddingTop: '18px'
  },
  methodBlockAfterDivider: {
    marginTop: '18px'
  },
  chooseOne: {
    alignItems: 'flex-start',
    backgroundColor: palette.info.light,
    display: 'flex',
    gap: '10px',
    marginTop: '24px',
    padding: '18px 24px'
  },
  chooseOneIcon: {
    flexShrink: 0,
    marginTop: '2px'
  },
  orDivider: {
    alignItems: 'center',
    display: 'flex',
    gap: '12px',
    marginTop: '24px',
    textTransform: 'uppercase',
    '&::before, &::after': {
      borderTop: "1px solid ".concat(palette.shades[200]),
      content: '""',
      flex: 1
    }
  },
  methodHeader: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'space-between',
    marginBottom: '6px'
  },
  step: {
    marginTop: '18px'
  },
  stepHeader: {
    alignItems: 'center',
    display: 'flex',
    gap: '10px'
  },
  stepNumber: {
    alignItems: 'center',
    backgroundColor: palette.primary.main,
    borderRadius: '50%',
    color: palette.common.white,
    display: 'inline-flex',
    flexShrink: 0,
    fontSize: '13px',
    fontWeight: 600,
    height: '24px',
    justifyContent: 'center',
    width: '24px'
  },
  stepDoneIcon: {
    flexShrink: 0
  },
  // Indented past the step marker, so each step's content reads as belonging to it.
  stepBody: {
    marginTop: '12px',
    paddingLeft: '34px'
  },
  smsToggle: {
    marginTop: '12px'
  },
  preferredHint: {
    marginLeft: '8px'
  },
  authIcon: {
    marginRight: '10px'
  },
  success: {
    backgroundColor: palette.success.light
  },
  danger: {
    backgroundColor: palette.error.light
  }
}));
export default useStyles;